import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//actions:
import { unlockCierreDiario, modifyDatosCierreDiario, getOtrosDatosCierreDiario, newOtrosDatosDB, updateOtrosDatosDB } from '../actions/cierre_diario_actions';
import { unlockCierreSemanal } from '../actions/cierre_semanal_actions';
import {
    setCentroDia,
    invalidateCentroDiaData,
    enableCentroDiaData,
} from '../actions/centro_dia_actions';
import { openDialog, loading } from '../actions/index';
import { setSaveState } from '../actions';


//component ui:
import DatePicker from '../components/utils/DatePicker';
//material ui:
import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import { Button, Paper } from '@material-ui/core';
import { Tooltip, Fade } from '@material-ui/core';

//helpers:
import { getData, postData, putData } from '../dataLib';

const styles = theme => ({
    form: {
        maxWidth: 600,
        display: 'flex',
        justifyContent: 'space-between',
    },
    select: {
        width: 180,
        margin: 0,
        padding: 0,
    },
    spinnerContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 40,
    },
    spinner: {
        width: '20px !important',
        height: '20px !important',
    },
    textField: {
        width: 150,
        margin: 0,
        padding: 0,
    },
    desbloquearContainer: {
        display: 'flex',
        width: 130,
    },
    acceptContainer: {
        display: 'flex',
        width: 95,
    },
    button: {
        borderRadius: 0,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        color: 'white',
        height: "100%",
        textTransform: 'capitalize',
        boxShadow: 'none',
    },
    paperCentroDia: {
        margin: 8,
    },
    tooltip: {
        fontSize: 14,
        color: 'white',
        backgroundColor: '#3a3434',
        fontWeight: 200,
    },
    buttonEnl: {
        padding: '0 5px',
        marginLeft: 10,
        backgroundColor: theme.palette.secondary.light,
        borderRadius: 0,
        fontSize: 10,
        // minWidth: 40,
        minWidth: 45,
        height: 35,
        '&:hover': {
            backgroundColor: '#cc8ebf'
        },
        boxShadow: '1px 1px 1px darkgrey',
        overflow: 'hidden'
    },
    buttonContentEnl: {
        display: 'flex',
        flexDirection: 'column',
    }
});

const NUM_ACTIVIDAES = 5;
const INDX_SIN_ACTIVIDADES = -1;
const INDX_ACTIVIDAD_BAR = 0;
const INDX_ACTIVIDAD_CUMPLE = 1;
const INDX_ACTIVIDAD_PARQUE = 2;
const INDX_ACTIVIDAD_BOLERA = 3;
const INDX_ACTIVIDAD_OTROS = 4;

class CentroDia extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            centroId: this.props.centroDiaSelected.centro.id
                ? this.props.centroDiaSelected.centro.id
                : 0,
            centroDescr: this.props.centroDiaSelected.centro.descr
                ? this.props.centroDiaSelected.centro.descr
                : '',
            centroDiaCierre: this.props.centroDiaSelected.centro.iDiaCierre
                ? this.props.centroDiaSelected.centro.iDiaCierre
                : 1,
            dia: this.props.centroDiaSelected.dia
                ? this.props.centroDiaSelected.dia
                : '2018-04-02',
            showButton: true,
            producto: {},
            productoRelacionado: {},
            producto_actividad: {},
            isSigfridLoaded: false,
            isTecBrainLoaded: false
        };
    }

    componentDidUpdate = (prevProps, prevState) => {

        //Comprobar si se han cargado los datos
        if (this.state.isSigfridLoaded && this.state.isTecBrainLoaded) {
            this.setState({ ...this.state, isSigfridLoaded: false, isTecBrainLoaded: false });
            this.props.openDialog('SimpleMessage', {
                message: "Sistemas enlazados importados"
            }, uuidv4(), false, 'sm');
            this.props.loading(false);
        }

        //Comprobacion de si hay dato en cierre diario para mostrar el boton para sincronizar
        //datos de sigfrid y tecbrain
        if (!this.props.semanal) {
            if (prevState.producto === this.state.producto) {
                let dataBar, dataPack;
                let dataActividad = [];
                for (let iActividad = 0 ; iActividad < NUM_ACTIVIDAES; iActividad ++)
                    dataActividad[iActividad] = {};
                if (this.props.datosCierreDiario.datos.length > 0) {
                    this.props.datosCierreDiario.datos.forEach(data => {
                        if (data.iKind === -7) {
                            dataBar = data;
                        }
                        if (data.iKind === -8) {
                            dataPack = data;
                        }
                        if ( data.iKind === -7) {
                            dataActividad[INDX_ACTIVIDAD_BAR] = data; // bar
                        }
                        if ( data.iTipoZona === 7 && data.isMovCaja === 0) {
                            dataActividad[INDX_ACTIVIDAD_CUMPLE] = data; // cumple
                        }
                        if ( data.iTipoZona === 10 && data.isMovCaja === 0) {
                            dataActividad[INDX_ACTIVIDAD_PARQUE] = data; // parque infantil
                        }
                        if ( data.iKind === -5 ) {
                            dataActividad[INDX_ACTIVIDAD_BOLERA] = data; // bolera
                        }
                        if ( data.iTipoZona === 6 && data.isMovCaja === 0) {
                            dataActividad[INDX_ACTIVIDAD_OTROS] = data; // otros juegos
                        }
                    });
                    //if (dataBar && dataPack) {
                    if (dataBar) {
                        // Se utilizará el bar como indicador de cambio de todos los productos
                        if (dataBar !== this.state.producto) {
                            this.props.getOtrosDatosCierreDiario(this.props.centroDiaSelected.centro.id, this.props.centroDiaSelected.dia);
                            this.setState({
                                ...this.state,
                                producto: dataBar,
                                productoRelacionado: dataPack,
                                producto_actividad: dataActividad
                            });
                        }
                    }
                }
            }
        }

        if (prevProps.isLoaded !== this.props.isLoaded && this.props.isLoaded) {
            this.setState({
                ...this.state, showButton: false
            });
        } else {
            if (
                prevProps.centroDiaSelected.centro.id !==
                this.props.centroDiaSelected.centro.id ||
                prevProps.centroDiaSelected.dia !==
                this.props.centroDiaSelected.dia
            ) {
                this.setState({
                    ...this.state,
                    centroId: this.props.centroDiaSelected.centro.id,
                    centroDescr: this.props.centroDiaSelected.centro.descr,
                    centroDiaCierre: this.props.centroDiaSelected.centro
                        .iDiaCierre,
                    dia: this.props.centroDiaSelected.dia
                });
            }
        }
    };

    componentDidMount = () => {

        if (this.props.isLoaded)
            this.setState({ ...this.state, showButton: false });
        this.props.enableCentroDiaData();
    };

    handleCentroValueChange = event => {
        const value = parseInt(event.target.value);

        let urlCierre =
            'CierreDiario/UtimoDiaCerrado?centro_id=' +
            value +
            '&semanal=' +
            this.props.semanal;

        getData(
            urlCierre,
            response => {
                var centro = this.props.centros.find(c => c.id === value);

                var dt = new Date(response.data);
                this.setState({
                    ...this.state,
                    centroId: value,
                    centroDescr: centro.descr,
                    centroDiaCierre: centro.iDiaCierre,
                    dia: dt.toISOString().slice(0, 10),
                    showButton: true,
                });
                this.props.invalidateCentroDiaData();
            },
            () => {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'error obteniendo última fecha de cierre',
                    },
                    'error-centro-dia-ultimo-dia',
                    false,
                    'sm',
                );
            },
            this.props.user,
        );
    };

    handleDiaValueChange = event => {

        var dt = new Date(event);

        if (this.props.semanal === true) {

            if (dt.getDay() !== this.state.centroDiaCierre) {
                this.props.openDialog(
                    'SimpleMessage',
                    {
                        message: 'Seleccione un día de cierre semanal',
                    },
                    'centro_dia_dia_cierre_semanal',
                    false,
                    'sm',
                );
                return;
            }
        }

        this.setState({ ...this.state, dia: dt.toISOString().slice(0, 10), showButton: true });
        this.props.invalidateCentroDiaData();
    };

    handleAceptarButtonClick = e => {
        e.preventDefault();
        if (this.props.centros.length) {
            if (this.props.semanal === true) {
                var dt = new Date(this.state.dia);
                if (dt.getDay() !== this.state.centroDiaCierre) {
                    this.props.openDialog(
                        'SimpleMessage',
                        {
                            message: 'Seleccione un día de cierre semanal',
                        },
                        'centro_dia_dia_cierre_semanal',
                        false,
                        'sm',
                    );
                    return;
                } else {
                    this.props.setCentroDia(
                        this.state.centroId,
                        this.state.dia,
                        this.props.semanal,
                        true,
                    );
                }
            } else {
                let urlCierre =
                    'CierreDiario/UtimoDiaCerrado?centro_id=' +
                    this.state.centroId;

                getData(
                    urlCierre,
                    response => {
                        var dt = new Date(response.data);
                        var dt_sel = new Date(this.state.dia);

                        if (dt_sel.getTime() > dt.getTime()) {
                            this.props.invalidateCentroDiaData();
                            this.props.openDialog(
                                'SimpleMessage',
                                {
                                    message:
                                        'El día: ' +
                                        dt.toLocaleDateString() +
                                        ' aún no ha sido cerrado',
                                },
                                'centro_dia_error_dia_cierre_semanal',
                                false,
                                'sm',
                            );

                            this.setState({
                                ...this.state,
                                dia: dt.toISOString().slice(0, 10),
                            });
                        } else {
                            this.props.setCentroDia(
                                this.state.centroId,
                                this.state.dia,
                                this.props.semanal,
                                true,
                            );
                        }
                    },
                    () => {
                        this.props.openDialog(
                            'SimpleMessage',
                            {
                                message:
                                    'error obteniendo última fecha de cierre',
                            },
                            'error-centro-dia-ultimo-dia',
                            false,
                            'sm',
                        );
                    },
                    this.props.user,
                );
            }
        }
    };

    centroSelectOptions = () => {
        return this.props.centros
            .filter(c => c.isGroup === false && c.activo === 1)
            .map((centro, index) => {
                return (
                    <option key={'centro_' + centro.id} value={centro.id}>
                        {centro.centro}
                    </option>
                );
            });
    };

    //#region Sigfrid
    updateDesglose = (iActividad, response, desgloseId, articuloId) => {

        const prod1 = iActividad === INDX_SIN_ACTIVIDADES ? this.state.producto : this.state.producto_actividad[iActividad];
        if (!prod1) return;
        const isBar = (iActividad === INDX_ACTIVIDAD_BAR || iActividad == INDX_SIN_ACTIVIDADES);
        const art2 = (this.state.productoRelacionado && isBar) ? this.state.productoRelacionado.articuloId : '0';
        const packs = isBar ? response.packs : 0;

        //console.log("UpdateDesglose", response.normal, packs);

        let desgloseURL = 'dadesglosehoras/' + desgloseId;
        desgloseURL += '?art1=' + prod1.articuloId + '&art2=' + art2 + '&normal=' + response.normal + '&packs=' + packs;
        putData(desgloseURL,
            () => {
                /* const message = this.state.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm'); */
                
                if ( isBar )
                    this.props.modifyDatosCierreDiario({ ...prod1, button1: response.normal + packs, importe: response.normal });
                else
                    this.props.modifyDatosCierreDiario({ ...prod1, importe: response.normal });

                if (this.state.productoRelacionado && isBar) {
                    this.props.modifyDatosCierreDiario({ ...this.state.productoRelacionado, importe: response.packs });
                }
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando ventas por hora'
                }, uuidv4(), false, 'sm');
            },
            { ...response.desglose, id: desgloseId, articuloId: articuloId, fecha: this.props.centroDiaSelected.dia },
            this.props.user
        );
    }

    newDesglose = (iActividad, response, articuloId) => {

        const prod1 = iActividad === INDX_SIN_ACTIVIDADES ? this.state.producto : this.state.producto_actividad[iActividad];
        if (!prod1) return;
        const isBar = (iActividad === INDX_SIN_ACTIVIDADES || iActividad === INDX_ACTIVIDAD_BAR);
        const art2 = (this.state.productoRelacionado && isBar) ? this.state.productoRelacionado.articuloId : '0';
        const packs = isBar ? response.packs : 0;

        let desgloseURL = 'dadesglosehoras';
        desgloseURL += '?art1=' + prod1.articuloId + '&art2=' + art2 + '&normal=' + response.normal + '&packs=' + packs;

        postData(desgloseURL,
            () => {
                /* const message = this.state.producto.iKind === -7 ? 'Ventas Bar y franjas horarias importadas' : 'Ventas por hora actualizadas'
                this.props.openDialog('SimpleMessage', {
                    message: message
                }, uuidv4(), false, 'sm'); */
                this.setState({ ...this.state, isSigfridLoaded: true });

                if ( isBar )
                    this.props.modifyDatosCierreDiario({ ...prod1, button1: response.normal + packs, importe: response.normal });
                else
                    this.props.modifyDatosCierreDiario({ ...prod1, importe: response.normal });

                if (this.state.productoRelacionado && isBar) {
                    this.props.modifyDatosCierreDiario({ ...this.state.productoRelacionado, importe: response.packs });
                }
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR updating desglose horas 2'
                }, uuidv4(), false, 'sm');
                this.setState({ ...this.state, isSigfridLoaded: true })
            },
            { ...response.desglose, id: -1, articuloId: articuloId, fecha: this.props.centroDiaSelected.dia },
            this.props.user
        );
    }

    updateDesgloseActividad = (iActividad,response) => {

        let desgloseURL = 'dadesglosehoras/simple';
        desgloseURL += '?articulo=' + this.state.producto_actividad[iActividad].articuloId + '&importe=' + response.normal + '&fecha=' + this.props.centroDiaSelected.dia;

        putData(desgloseURL,
            () => {               
                this.props.modifyDatosCierreDiario({ ...this.state.producto_actividad[iActividad], importe: response.normal });
            },
            () => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR actualizando actividades'
                }, uuidv4(), false, 'sm');
            },
            {},
            this.props.user
        );
    }

    sigfridHandler = (iActividad,sigfrid) => {

        if ( iActividad !== INDX_SIN_ACTIVIDADES && 
             this.state.producto_actividad[iActividad].articuloId === undefined ) {
            return;
        }
        const zona_id = iActividad === INDX_SIN_ACTIVIDADES ? this.state.producto.zonaId : this.state.producto_actividad[iActividad].zonaId;
        if ( iActividad !== INDX_ACTIVIDAD_BOLERA)
        {
            let desgloseURL = (iActividad === INDX_SIN_ACTIVIDADES) ?
                'dadesglosehoras/cierrediario?zona_id=' + zona_id + '&date=' + this.props.centroDiaSelected.dia
                :
                'dadesglosehoras/actividad?articulo_id=' + this.state.producto_actividad[iActividad].articuloId + '&date=' + this.props.centroDiaSelected.dia;

            getData(desgloseURL,
                (response) => {
                    if (response.data.id === -1) {
                        this.newDesglose(iActividad, sigfrid, response.data.articuloId);
                    } //nuevo desglose
                    else {
                        this.updateDesglose(iActividad, sigfrid, response.data.id, response.data.articuloId);
                    } //actualizar desglose

                    this.setState({ ...this.state, isSigfridLoaded: true })
                },
                (error) => {
                    this.props.openDialog('SimpleMessage', {
                        message: 'ERROR fetching desglose horas - ' + error
                    }, uuidv4(), false, 'sm');
                    this.setState({ ...this.state, isSigfridLoaded: true })
                },
                this.props.user
            );
        }
        else
        {
            // Para la bolera solo actualiza el total
            if ( sigfrid.normal !== 0.0)
                this.updateDesgloseActividad(iActividad, sigfrid);
        }


    }

    importSigfrid = (thenHandler) => {

        const getURL = 'sigfrid?centro_id=' + this.props.centroDiaSelected.centro.sigfrid + '&date=' + this.props.centroDiaSelected.dia;
        
        getData(getURL,
            (response) => {

                let totales = [];
                let totales_actividad = [];

                let normal = 0.0;
                let packs = 0.0;
                let actividad = [];
                for (let iActividad = 0 ; iActividad < NUM_ACTIVIDAES; iActividad++) 
                {
                    actividad[iActividad]=0.0;
                    totales_actividad[iActividad] = [];
                    //fbp
                    for (let iHora = 0; iHora < 24; iHora++)
                        totales_actividad[iActividad][iHora] = 0.0;
                }

                for (const key in response.data.datos) {

                    if (key !== "local" && key !== "fecha" && key !== "cabeceras" && key !== "totales") {

                        const linea = response.data.datos[key];

                        //if (linea[20].value21 === null || linea[20].value21 === '') {

                        if (linea[10].value11 !== '002' && linea[10].value11 !== '001') {

                            const hora = parseInt(linea[12].value13.slice(0, 2));
                            const importe = parseFloat(linea[8].value9.replace('.', '').replace(',', '.'));
                            const tipo = linea[13].value14;
                            const tipo_tpv = linea[1].value2;

                            if (totales[hora] !== undefined) totales[hora] += importe;
                            else totales[hora] = importe;

                            if (tipo === "MESA") {
                                 packs += importe;
                            } else {
                                 // ya no es particular el TPV2
                                // if ( tipo_tpv === "002" )
                                // {
                                //     packs += linea[23].value24;
                                // } else {
                                //     normal += importe;
                                // }
                                normal += importe;
                            }

                            let importe_act = []
                            // fbp
                            //importe_act[INDX_ACTIVIDAD_BAR] = tipo_tpv !== "002" ? linea[23].value24 : 0;
                            // ya no es particular el TPV2 importe_act[INDX_ACTIVIDAD_BAR] = tipo !== "MESA" && tipo_tpv !== "002" ? linea[23].value24 : 0;
                            importe_act[INDX_ACTIVIDAD_BAR] = tipo !== "MESA" ? linea[23].value24 : 0;
                            importe_act[INDX_ACTIVIDAD_CUMPLE] = linea[24].value25;
                            importe_act[INDX_ACTIVIDAD_PARQUE] = linea[25].value26;
                            importe_act[INDX_ACTIVIDAD_BOLERA] = linea[26].value27;
                            importe_act[INDX_ACTIVIDAD_OTROS] = linea[27].value28;
                            for (let iActividad = 0 ; iActividad < NUM_ACTIVIDAES; iActividad++)
                            {
                                if (totales_actividad[iActividad][hora] !== undefined) 
                                    totales_actividad[iActividad][hora] += importe_act[iActividad];
                                else 
                                    totales_actividad[iActividad][hora] = importe_act[iActividad];
                                // en el caso del bar se añade al desglose las ventas de pack
                                // ya no es particular el TPV2 if (iActividad === INDX_ACTIVIDAD_BAR && tipo_tpv === "002")
                                if (iActividad === INDX_ACTIVIDAD_BAR  && tipo === "MESA")
                                    totales_actividad[iActividad][hora] += linea[23].value24;
                                actividad[iActividad] += importe_act[iActividad];
                            }
                        }
                    }
                }

                var newDesglose = {};
                let antes12 = 0.0;
                for (let i = 5; i <= 12; i++) {
                    if (totales[i] !== undefined) antes12 += totales[i];
                }
                newDesglose.hora01 = antes12;
                newDesglose.hora02 = totales[13] ? totales[13] : 0.0;
                newDesglose.hora03 = totales[14] ? totales[14] : 0.0;
                newDesglose.hora04 = totales[15] ? totales[15] : 0.0;
                newDesglose.hora05 = totales[16] ? totales[16] : 0.0;
                newDesglose.hora06 = totales[17] ? totales[17] : 0.0;
                newDesglose.hora07 = totales[18] ? totales[18] : 0.0;
                newDesglose.hora08 = totales[19] ? totales[19] : 0.0;
                newDesglose.hora09 = totales[20] ? totales[20] : 0.0;
                newDesglose.hora10 = totales[21] ? totales[21] : 0.0;
                newDesglose.hora11 = totales[22] ? totales[22] : 0.0;
                newDesglose.hora12 = totales[23] ? totales[23] : 0.0;
                newDesglose.hora13 = totales[0] ? totales[0] : 0.0;
                newDesglose.hora14 = totales[1] ? totales[1] : 0.0;
                newDesglose.hora15 = totales[2] ? totales[2] : 0.0;
                newDesglose.hora16 = totales[3] ? totales[3] : 0.0;
                newDesglose.hora17 = totales[4] ? totales[4] : 0.0;
                newDesglose.hora18 = 0.0;
                newDesglose.hora19 = 0.0;
                newDesglose.hora20 = 0.0;
                newDesglose.hora21 = 0.0;
                newDesglose.hora22 = 0.0;
                newDesglose.hora23 = 0.0;
                newDesglose.hora24 = 0.0;

                var newDesglose_actividad =[]
                for (let iActividad = 0 ; iActividad < NUM_ACTIVIDAES ; iActividad++)
                {
                    newDesglose_actividad[iActividad] = {};
                    let antes12_act = 0.0;
                    for (let i = 5; i <= 12; i++) {
                        // fbp
                        //if (newDesglose_actividad[iActividad][i] !== undefined) antes12_act += newDesglose_actividad[iActividad][i];
                        if (totales_actividad[iActividad][i] !== undefined) antes12_act += totales_actividad[iActividad][i];
                    }
                    newDesglose_actividad[iActividad].hora01 = antes12_act;
                    newDesglose_actividad[iActividad].hora02 = totales_actividad[iActividad][13] ? totales_actividad[iActividad][13] : 0.0;
                    newDesglose_actividad[iActividad].hora03 = totales_actividad[iActividad][14] ? totales_actividad[iActividad][14] : 0.0;
                    newDesglose_actividad[iActividad].hora04 = totales_actividad[iActividad][15] ? totales_actividad[iActividad][15] : 0.0;
                    newDesglose_actividad[iActividad].hora05 = totales_actividad[iActividad][16] ? totales_actividad[iActividad][16] : 0.0;
                    newDesglose_actividad[iActividad].hora06 = totales_actividad[iActividad][17] ? totales_actividad[iActividad][17] : 0.0;
                    newDesglose_actividad[iActividad].hora07 = totales_actividad[iActividad][18] ? totales_actividad[iActividad][18] : 0.0;
                    newDesglose_actividad[iActividad].hora08 = totales_actividad[iActividad][19] ? totales_actividad[iActividad][19] : 0.0;
                    newDesglose_actividad[iActividad].hora09 = totales_actividad[iActividad][20] ? totales_actividad[iActividad][20] : 0.0;
                    newDesglose_actividad[iActividad].hora10 = totales_actividad[iActividad][21] ? totales_actividad[iActividad][21] : 0.0;
                    newDesglose_actividad[iActividad].hora11 = totales_actividad[iActividad][22] ? totales_actividad[iActividad][22] : 0.0;
                    newDesglose_actividad[iActividad].hora12 = totales_actividad[iActividad][23] ? totales_actividad[iActividad][23] : 0.0;
                    newDesglose_actividad[iActividad].hora13 = totales_actividad[iActividad][0] ? totales_actividad[iActividad][0] : 0.0;
                    newDesglose_actividad[iActividad].hora14 = totales_actividad[iActividad][1] ? totales_actividad[iActividad][1] : 0.0;
                    newDesglose_actividad[iActividad].hora15 = totales_actividad[iActividad][2] ? totales_actividad[iActividad][2] : 0.0;
                    newDesglose_actividad[iActividad].hora16 = totales_actividad[iActividad][3] ? totales_actividad[iActividad][3] : 0.0;
                    newDesglose_actividad[iActividad].hora17 = totales_actividad[iActividad][4] ? totales_actividad[iActividad][4] : 0.0;
                    newDesglose_actividad[iActividad].hora18 = 0.0;
                    newDesglose_actividad[iActividad].hora19 = 0.0;
                    newDesglose_actividad[iActividad].hora20 = 0.0;
                    newDesglose_actividad[iActividad].hora21 = 0.0;
                    newDesglose_actividad[iActividad].hora22 = 0.0;
                    newDesglose_actividad[iActividad].hora23 = 0.0;
                    newDesglose_actividad[iActividad].hora24 = 0.0;
                }

                let sum_act = 0.0
                for(let iActividad = 0 ; iActividad < NUM_ACTIVIDAES; iActividad++) 
                    sum_act +=actividad[iActividad]

                // console.log("SIGFRID")
                // console.log("sum_act",sum_act)
                // console.log("actividad", actividad)
                // console.log("producto_relacionado", this.state.productoRelacionado)
                // console.log("normal", normal)
                // console.log("packs", packs)
                // console.log("newDesglose", newDesglose)
                if ( sum_act === 0.0 )
                {
                    // SIN ACTIVIDADES
                    if (!this.state.productoRelacionado) 
                        thenHandler(INDX_SIN_ACTIVIDADES,{ desglose: newDesglose, normal: normal + packs, packs: 0 });
                    else 
                        thenHandler(INDX_SIN_ACTIVIDADES,{ desglose: newDesglose, normal: normal, packs: packs });
                }
                else
                {
                    for ( let iActividad = 0 ; iActividad < NUM_ACTIVIDAES ; iActividad++)
                    {
                        thenHandler(iActividad,{ desglose: newDesglose_actividad[iActividad], normal: actividad[iActividad], packs: packs });
                    }
                }
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR fetching sigfrid - ' + error
                }, uuidv4(), false, 'sm');
                this.setState({ ...this.state, isSigfridLoaded: true })
            },
            this.props.user
        );
    }

    //#endregion

    thenTecBrainCount = () => {
        this.props.setSaveState(false);
        this.setState({ ...this.state, isTecBrainLoaded: true });
        this.props.loading(false);
    }

    formatDate(date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('');
    }

    updateCountPersonTecBrain = () => {
        let start = this.state.dia.split('-');
        let jsstart = new Date(start[0],start[1]-1,start[2]);
        let jsend = new Date(start[0],start[1]-1,start[2]);
        jsend.setDate(jsend.getDate() + 1);
        
        let strStart = this.formatDate(jsstart);
        let strEnd = this.formatDate(jsend);
        //  console.log(strStart,strEnd);
        postData(`DCConteoPersonas?start=${strStart}1000&end=${strEnd}0959&idCenter=${this.state.centroId}`,
            (response) => {

                if (response.data) {
                    const otrosDatos = this.props.otrosDatosCierreDiario.datos;
                    //console.log(otrosDatos);
                    otrosDatos.numeroPersonas = response.data;
                    const id = !otrosDatos.id ? 0 : otrosDatos.id;
                    if (id === 0) {
                        this.props.newOtrosDatosDB(otrosDatos, this.thenTecBrainCount, () => {
                            this.props.loading(false);
                        });
                    } else {
                        this.props.updateOtrosDatosDB(otrosDatos, id, this.thenTecBrainCount, () => {
                            this.props.loading(false);
                        });
                    };
                }
                else {
                    this.thenTecBrainCount();
                }
            },
            (error) => {
                this.props.openDialog('SimpleMessage', {
                    message: 'ERROR tec brain' + error
                }, uuidv4(), false, 'sm');
                this.setState({ ...this.state, isTecBrainLoaded: true });
            }, undefined,
            this.props.user
        );
    }

    renderDesbloquearButton = () => {
        const { classes } = this.props;

        if (
            this.props.semanal &&
            this.props.centroDiaSelected.isSemanaCerrada
        ) {
            return this.props.centroDiaSelected.isValid ? (
                <Tooltip
                    title="Semana cerrada, pulse aquí para desbloquearla"
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    classes={{ tooltip: this.props.classes.tooltip }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                            this.props.unlockCierreSemanal(
                                this.state.centroId,
                                this.state.dia,
                            );
                        }}
                        disabled={false}
                    >
                        Desbloquear
                    </Button>
                </Tooltip>
            ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                            this.props.unlockCierreSemanal(
                                this.state.centroId,
                                this.state.dia,
                            );
                        }}
                        disabled={true}
                    >
                        Desbloquear
                    </Button>
                );
        } else if (
            this.props.semanal !== true &&
            this.props.centroDiaSelected.isDiaCerrado
        ) {
            return this.props.centroDiaSelected.isValid ? (
                <Tooltip
                    title="Día cerrado, pulse aquí para desbloquearlo"
                    TransitionComponent={Fade}
                    TransitionProps={{ timeout: 600 }}
                    classes={{ tooltip: this.props.classes.tooltip }}
                >
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                            this.props.unlockCierreDiario(
                                this.state.centroId,
                                this.state.dia,
                            );
                        }}
                        disabled={false}
                    >
                        Desbloquear
                    </Button>
                </Tooltip>
            ) : (
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => {
                            this.props.unlockCierreDiario(
                                this.state.centroId,
                                this.state.dia,
                            );
                        }}
                        disabled={true}
                    >
                        Desbloquear
                    </Button>
                );
        }
    };

    render() {
        const { classes } = this.props;


        return (
            <Paper className={classes.paperCentroDia} elevation={0}>
                <Grid container direction="row" >
                    <Grid container direction="row" item sm={9} >
                        {this.props.userProfile.selectedCentroProfile !==
                            undefined &&
                            [0, 4, 5, 16, 17, 20].includes(
                                this.props.userProfile.selectedCentroProfile.iPerfil,
                            ) ? (
                                <FormControl >
                                    <InputLabel htmlFor="centro-placeholder">
                                        Centro
                                    </InputLabel>
                                    <Select
                                        native
                                        value={this.state.centroId}
                                        onChange={event =>
                                            this.handleCentroValueChange(event)
                                        }
                                        name="centro"
                                    >
                                        {this.props.centros
                                            .filter(
                                                c =>
                                                    c.isGroup === false &&
                                                    c.activo === 1,
                                            )
                                            .find(c => c.id === this.state.centroId) ===
                                            undefined ? (
                                                <option key={'centro_0'} value={0}>
                                                    {'Seleccione un centro'}
                                                </option>
                                            ) : (
                                                ''
                                            )}
                                        {this.centroSelectOptions()}
                                    </Select>
                                </FormControl>
                            ) : (
                                ''
                            )}

                        {this.props.userProfile.selectedCentroProfile !==
                            undefined &&
                            [0, 4, 5, 16, 17, 20].includes(
                                this.props.userProfile.selectedCentroProfile.iPerfil,
                            ) ? (
                                <div className={classes.spinnerContainer}>
                                    {this.props.isLoading ? (
                                        <CircularProgress
                                            className={classes.spinner}
                                            color="primary"
                                        />
                                    ) : (
                                            ''
                                        )}
                                </div>
                            ) : (
                                ''
                            )}

                        {this.state.centroId !== 0 ? (
                            <DatePicker
                                label="Fecha"
                                value={this.state.dia}
                                className={classes.textField}
                                style={{
                                    backgroundColor: this.props.semanal
                                        ? '#e8f1d7'
                                        : '',
                                }}
                                isSemanal={this.props.semanal}
                                onChange={event => {
                                    if (event && !isNaN(event)) {
                                        const d = new Date(Date.UTC(event.getFullYear(), event.getMonth(), event.getDate()));
                                        this.handleDiaValueChange(d);
                                    }
                                }}
                            />
                        ) : (
                                ''
                            )}

                        {this.state.centroId !== 0 &&
                            ([0, 4, 5, 15, 17, 18].includes(
                                this.props.userProfile.selectedCentroProfile.iPerfil,
                            ) || (this.props.userProfile.selectedCentroProfile.iPerfil === 15 && this.props.semanal)) ? (
                                <div className={classes.desbloquearContainer}>
                                    {this.renderDesbloquearButton()}
                                </div>
                            ) : (
                                ''
                            )}

                        {this.state.centroId !== 0 ? (
                            <Grid item xs={2}>
                                {this.state.showButton ? (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        fullWidth
                                        disabled={
                                            this.props.isLoading ||
                                            this.props.centros.find(
                                                c => c.id === this.state.centroId,
                                            ) === undefined
                                        }
                                        className={classes.button}
                                        onClick={this.handleAceptarButtonClick}
                                    >
                                        Aceptar
                                    </Button>
                                ) : (
                                        ''
                                    )}
                            </Grid>
                        ) : (
                                ''
                            )}

                    </Grid>
                    <Grid container item justify="flex-end"
                        alignItems="center" sm={3} style={{ padding: "5px" }}>
                        {this.state.producto.zonaId && this.props.otrosDatosCierreDiario.loaded === true &&
                            this.props.otrosDatosCierreDiario.isLoading === false && !this.props.centroDiaSelected.isDiaCerrado ?
                            <Grid item xs={12}>
                                <Button fullWidth variant="contained" size="small" className={classes.buttonEnl} onClick={() => 
                                    {
                                        this.props.loading(true);
                                        this.importSigfrid(this.sigfridHandler); 
                                        this.updateCountPersonTecBrain(); 
                                    }}>
                                    <div className={classes.buttonContentEnl} > {'Importar_sistemas enlazados'} </div>
                                </Button>
                            </Grid>
                            :
                            null}
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

CentroDia.propTypes = {
    //state:
    centroDiaSelected: PropTypes.object.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    centros: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    //dispatch:
    unlockCierreDiario: PropTypes.func.isRequired,
    unlockCierreSemanal: PropTypes.func.isRequired,
    setCentroDia: PropTypes.func.isRequired,
    invalidateCentroDiaData: PropTypes.func.isRequired,
    enableCentroDiaData: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        centros: state.centros.centros,
        isLoading: state.centros.isLoading,
        centroDiaSelected: state.centroDiaSelected,
        isLoaded: state.centroDiaSelected.isLoaded,
        userProfile: state.userProfile,
        datosCierreDiario: state.datosCierreDiario,
        otrosDatosCierreDiario: state.otrosDatosCierreDiario
        // isDiaCerrado: state.centroDiaSelected.isDiaCerrado,
    };
}

function mapDispathToProps(dispatch) {
    return bindActionCreators(
        {
            unlockCierreDiario,
            unlockCierreSemanal,
            setCentroDia,
            openDialog,
            invalidateCentroDiaData,
            enableCentroDiaData,
            modifyDatosCierreDiario,
            getOtrosDatosCierreDiario,
            updateOtrosDatosDB,
            newOtrosDatosDB,
            setSaveState,
            loading
        },
        dispatch,
    );
}

export default connect(
    mapStateToProps,
    mapDispathToProps,
)(withStyles(styles, { withTheme: true })(CentroDia));
